
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent(
{
    name: 'PayDeclined',
    setup()
    {
        // Load router:
        const router = useRouter()
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']

        // Display error:
        store.commit('errors/setNuxeoErrors',
        {
            message: 'Payment declined: Declined'
        })
        router.push({ hash: '#error-summary-container' })
        // Return data:
        return {
            isAuthenticated
        }
    }
})
